import z from 'zod';

export const keyNameFormSchema = z.object({ keyName: z.string().min(3) });
